import './ui/styles.css';
import { createGame } from './game/MathNinjaGame';
import { useGameStore } from './state/gameStore';
import { useAuthStore } from './state/authStore';
import { authService } from './services/authService';
import { audioService } from './services/audioService';
import { userProfileService } from './services/userProfileService';
import { showMenu } from './ui/MenuOverlay';
import { showGameOver } from './ui/GameOverOverlay';
import { initInstallPrompt } from './ui/InstallPromptOverlay';
import { clearRoot } from './ui/dom';
import { isFirebaseConfigured } from './config/firebase';

const game = createGame('game-container');

audioService.init();

initInstallPrompt();

bootAuth();

let lastScreen = useGameStore.getState().screen;
applyScreen(lastScreen);

useGameStore.subscribe((state) => {
  if (state.screen !== lastScreen) {
    lastScreen = state.screen;
    applyScreen(state.screen);
  }
});

async function bootAuth(): Promise<void> {
  const identity = authService.init();
  useAuthStore.getState().setUser({
    uid: identity.uid,
    displayName: null,
    isAnonymous: identity.isAnonymous
  });
  useAuthStore.getState().setReady(true);

  if (!isFirebaseConfigured()) return;

  try {
    const profile = await userProfileService.load(identity.uid);
    if (profile) {
      useAuthStore.getState().setProfile({
        nickname: profile.nickname,
        bestScore: profile.bestScore,
        bestLevel: profile.bestLevel,
        totalGames: profile.totalGames
      });
      if (useGameStore.getState().screen === 'menu') {
        showMenu();
      }
    }
  } catch (err) {
    console.error('profile load failed', err);
  }
}

function applyScreen(screen: ReturnType<typeof useGameStore.getState>['screen']): void {
  const gameScene = game.scene.getScene('Game');
  switch (screen) {
    case 'menu':
      clearRoot();
      showMenu();
      // La escena Game corre como demo de fondo (vidas infinitas, no afecta al jugador).
      // Si estaba detenida (post game over) la arrancamos de nuevo.
      if (gameScene && !gameScene.scene.isActive('Game')) {
        gameScene.scene.start('Game');
      }
      break;
    case 'game':
    case 'tutorial':
      clearRoot();
      if (gameScene) {
        if (gameScene.scene.isActive('Game')) {
          gameScene.scene.restart();
        } else {
          gameScene.scene.start('Game');
        }
      } else {
        game.scene.start('Game');
      }
      break;
    case 'gameover':
      showGameOver();
      break;
    case 'leaderboard':
    case 'settings':
      break;
  }
}

window.addEventListener('beforeunload', () => {
  game.destroy(true);
});
